import { AxiosAPI, getUserID } from '../helpers/AxiosAPI';
import { API_CurrencyManager, gAPI_Groups } from '../constants/APIs';

export async function GetCurrencyConversion(groupId) {
  var rate = 0;
  await AxiosAPI({
    methhod: 'get',
    url: `${gAPI_Groups}/${getUserID()}`,
  }).then(async (res) => {
    var cgroupid = res.data.filter((l) => l.groupId === groupId);
    if (cgroupid.length > 0) {
      await AxiosAPI({
        method: 'get',
        url: `${API_CurrencyManager}/list`,
      })
        .then((response) => {
          var list = response.data.filter(
            (k) => k.fromCurrency === cgroupid[0].billingCurrency
          );
          if (list.length > 0) {
            rate = list[0].rate;
          }
        })
        .catch((error) => error);
    }
  });
  return rate;
}
